<template>
    <div class="sa-list-component">
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <span class="sa-flexbox-body-title">Aachener Aphasie Test</span>
                <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" class="mb-2" :disabled="isLoading || isDeleting" @click="onClickAggiungi">
                    <i class="fas fa-plus"></i>
                    Aggiungi
                </b-button>
                <b-table v-if="items.length > 0 || isLoading" sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :busy="isLoading" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template v-slot:cell(createDate)="{ item }">
                        <span>Aachener Aphasie Test del {{ formatDateTime(item.createDate) }}</span>
                    </template>
                    <template v-slot:cell(createUser)="{ item }">
                        <span>{{ item.createUser }}</span>
                    </template>
                    <template v-slot:cell(updateDate)="{ item }">
                        <span>{{ formatDateTime(item.updateDate) }}</span>
                    </template>
                    <template #cell(action)="{ item }">
                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover class="mr-1 ml-1 no-text" size="sm" variant="outline-secondary width-sm no-text" title="Visualizza" aria-label="Visualizza" :disabled="isLoading || isDeleting" @click="onClickVisualizzaScheda(item)">
                                <i class="fas fa-eye"></i>
                            </b-button>
                            <b-button v-b-tooltip.hover class="mr-1 ml-1 no-text" size="sm" variant="outline-success width-sm no-text" title="Modifica" aria-label="Modifica" :disabled="isLoading || isDeleting" @click="onClickModificaScheda(item)">
                                <i class="fas fa-edit"></i>
                            </b-button>
                            <b-button v-b-tooltip.hover class="mr-1 ml-1 no-text" size="sm" variant="outline-danger width-sm no-text" title="Elimina" aria-label="Elimina" :disabled="isLoading || isDeleting" @click="onClickDeleteScheda(item)">
                                <i class="fas fa-trash"></i>
                            </b-button>
                        </b-container>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-muted py-4">Caricamento schede...</div>
                    </template>
                </b-table>
                <no-data-component v-else ref="cmpNoDataComponent" title="Non sono presenti schede Aachener Aphasie Test per il paziente" nome="no-data" subtitle="" icon="fas fa-users"></no-data-component>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info mx-2">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" :disabled="isLoading || isDeleting" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <rsa-paziente-scheda-aachener-aphasie-test-modal-edit ref="cmpAachenerAphasieTestModal" @beforeLoadData="$emit('beforeLoadData')" @afterLoadData="$emit('afterLoadData')" @afterSave="onAfterSave"></rsa-paziente-scheda-aachener-aphasie-test-modal-edit>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaPazienteSchedaAachenerAphasieTestModalEdit from "./RsaPazienteSchedaAachenerAphasieTestModalEdit.vue";
import NoDataComponent from "../../../../template/components/utility/NoDataComponent.vue";

export default {
    name: "RsaPazienteSchedaAachenerAphasieTestListComponent",
    mixins: [UtilityMixin],
    components: { RsaPazienteSchedaAachenerAphasieTestModalEdit, NoDataComponent },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            isLoading: false,
            isDeleting: false,
            pathResource: "/aacheneraphasietest",
            filtroAachenerAphasieTest: {
                idAccettazione: null,
            },
            idAccettazione: null,
            items: [],
            fields: [
                {
                    label: "",
                    key: "index",
                    thStyle: "width: 3rem",
                },
                {
                    label: "Scheda",
                    key: "createDate",
                    sortable: true,
                },
                {
                    label: "Autore",
                    key: "createUser",
                    sortable: true,
                },
                {
                    label: "Ultima modifica",
                    key: "updateDate",
                    sortable: true,
                },
                {
                    label: "",
                    key: "action",
                    class: "sa-table-column-action-double",
                },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        onClickAggiungi() {
            this.$refs.cmpAachenerAphasieTestModal.show(this.idAccettazione);
        },
        onAfterSave() {
            this.loadData();
        },
        init(idAccettazione) {
            let me = this;
            let isNuovoPaziente = me.idAccettazione !== idAccettazione;
            me.idAccettazione = idAccettazione;
            if (isNuovoPaziente && me.currentPage !== 1) {
                me.currentPage = 1;
            } else {
                me.loadData();
            }
        },
        loadData() {
            let me = this;

            me.isLoading = true;
            me.$emit("beforeLoadData");
            me.filtroAachenerAphasieTest.idAccettazione = me.idAccettazione;
            me.filtroAachenerAphasieTest.page = me.currentPage;
            me.filtroAachenerAphasieTest.forPage = me.perPage;
            me.loadDataResources(me.pathResource, me.filtroAachenerAphasieTest, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            if (response.data.esito === false || !response.data.data || !Array.isArray(response.data.data.list)) {
                me.loadDataError(new Error(response.data.messaggio || "Risposta elenco non valida"));
                return;
            }
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.isLoading = false;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            me.items = [];
            me.rows = 0;
            me.isLoading = false;
            me.$emit("afterLoadData");
            let messaggio = error.response && error.response.data && error.response.data.messaggio ? error.response.data.messaggio : error.message;
            me.$bvToast.toast(messaggio || "Errore durante il caricamento delle schede", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onClickVisualizzaScheda(item) {
            let me = this;
            me.$refs.cmpAachenerAphasieTestModal.visualizzaScheda(item, me.idAccettazione);
        },
        onClickModificaScheda(item) {
            let me = this;
            me.$refs.cmpAachenerAphasieTestModal.modificaScheda(item, me.idAccettazione);
        },
        onClickDeleteScheda(item) {
            let me = this;
            if (me.isLoading || me.isDeleting) return;
            me.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Eliminazione Scheda",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteScheda(item.id);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteScheda(id) {
            let me = this;
            if (me.isDeleting) return;
            me.isDeleting = true;
            me.$emit("beforeLoadData");
            me.deleteResource(me.pathResource + "/" + id, me.deleteSchedaSuccess, me.deleteSchedaError);
        },
        deleteSchedaSuccess(response) {
            let me = this;
            if (response.data.esito === false) {
                me.deleteSchedaError(new Error(response.data.messaggio));
                return;
            }
            me.isDeleting = false;
            me.loadData();
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        deleteSchedaError(error) {
            let me = this;
            me.isDeleting = false;
            me.$emit("afterLoadData");
            let messaggio = error.response && error.response.data && error.response.data.messaggio ? error.response.data.messaggio : error.message || "Errore durante l'eliminazione";
            me.$bvToast.toast(messaggio, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>
